import React, { useEffect, useRef, useState } from "react";
import { Form, Select, Button, DatePicker, Radio, Checkbox, Input } from "antd";
import {
  aadharPattern,
  panPattern,
  pincodePattern,
  mobilePattern,
  emailPattern,
  filterOption,
  dispatchtoast,
} from "../../../Utils";
import {
  addMember,
  addUser,
  getCity,
  getCountry,
  getState,
  getmemberPackages,
  getmemberType,
} from "../../../ApiServices/Apifun";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import CommonInput from "../../../Common/CommonInput";
const AddUser = () => {
  const formRef = useRef();
  const [form] = Form.useForm();
  const [membercustomPayload, setCustomMemberPayload] = useState({});
  const [country, setCountry] = useState([]);
  const [check, setcheck] = useState(false);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberType, setMemberType] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(setselectedTab("15"));
    if (profiledetail.member_type === "Retailer") {
      navigate("/dashboard");
    } else {
      getCountry()
        .then((res) => {
          setCountry(
            res.countries.map((i, index) => {
              return {
                label: i.name,
                value: i.id,
                key: i.id,
              };
            }),
          );
        })
        .catch((err) => console.log(err));
      getmemberType()
        .then((res) => {
          setMemberType(
            res.data.map((i) => {
              return {
                label: i.type,
                value: i.id,
                key: i.id,
              };
            }),
          );
        })
        .catch((err) => console.log(err));
    }
  }, []);
  const handleGetPackage = (val) => {
    setSelectedMember(val);
    setCustomMemberPayload({});
    getmemberPackages({ member_type: val })
      .then((res) => setPackages(res.packages))
      .catch((err) => console.log(err));
  };
  const handleGetState = (val) => {
    const payload = {
      country_id: val,
    };
    getState(payload)
      .then((res) => {
        setState(
          res.states.map((i, index) => {
            return {
              label: i.name,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };
  const handleGetCity = (val) => {
    const payload = {
      state_id: val,
    };
    getCity(payload)
      .then((res) => {
        setCity(
          res.cities.map((i, index) => {
            return {
              label: i.name,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };
  const handleAutoFill = (e) => {
    form.getFieldValue(country);
    setcheck(e.target.checked);
    formRef.current.setFieldsValue({
      business_country: form.getFieldValue("country"),
      business_state: form.getFieldValue("state"),
      business_city: form.getFieldValue("city"),
      business_zip: form.getFieldValue("zip"),
    });
  };
  const handleFinish = (val) => {
    let data = { ...val };
    data.pan = data.pan.toUpperCase();
    data.dob = dayjs(data.dob).format("YYYY-MM-DD");
    const formdata = new FormData();

    Object.entries(data).forEach(([key, val]) => formdata.append(key, val));
    addUser(formdata)
      .then((res) => {
        if (res.status) {
          window.open(res.redUrl, "_blank");
          navigate("/Report/user-report");
          //   dispatchtoast(res.message);
          //   navigate("/dashboard");
        }
      })
      .catch((err) => console.log(err));
  };
  const roleOptions = () => {
    switch (profiledetail?.role_type) {
      case "BDM":
        return [
          { label: "ASP", value: "ASP" },
          { label: "DSA", value: "DSA" },
        ];

      case "ASP":
        return [{ label: "DSA", value: "DSA" }];

      case "DSA":
        return [{ label: "DSA", value: "DSA" }];

      default:
        return [];
    }
  };
  return (
    <>
      <div className="bg-white rounded-md">
        <div className="p-4 ">
          <Form
            form={form}
            ref={formRef}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleFinish(val)}
          >
            <p className="text-md  font-semibold">Add User</p>
            <p className="mt-4 font-semibold">User Details</p>
            <div className="grid xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-x-5">
              <Form.Item
                name={`name`}
                label={"Full Name"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Full Name!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Your Full Name" name="name" />
              </Form.Item>
              <Form.Item
                name={`mobile`}
                label={"Mobile Number"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter your Mobile Number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Invalid mobile number!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Your Mobile" name="mobile" />
              </Form.Item>{" "}
              <Form.Item
                name={`email`}
                label={"Email Address"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter your Email!",
                  },
                  {
                    pattern: emailPattern,
                    message: "Enter Valid Email!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Your Email " name="email" />
              </Form.Item>{" "}
              <Form.Item
                name={`aadhar`}
                label={"Aadhar "}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Aadhar !",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Invalid Aadhaar card number format!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Your Aadhar " name="aadhar" />
              </Form.Item>
              <Form.Item
                name={`pan`}
                label={"Pan Card"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Pan!",
                  },
                  {
                    pattern: panPattern,
                    message: "Invalid PAN format!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Pan" name="pan" />
              </Form.Item>
              <Form.Item
                name={`address`}
                label={"Address"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Address!",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="Enter Your Address"
                  name="address"
                />
              </Form.Item>{" "}
              <Form.Item
                name={`dob`}
                label={"Date Of Birth"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Date Of Birth!",
                  },
                ]}
              >
                <DatePicker
                  popupClassName="bottom-calendar"
                  className="w-full datepicker h-9"
                  onChange={() => {}}
                  placement="bottomLeft"
                  placeholder="Enter DOB"
                />
              </Form.Item>
              <Form.Item
                name="role_type"
                label="Your Role"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select role!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select Role--"
                  showSearch
                  className="w-full mt-2"
                  options={roleOptions()}
                />
              </Form.Item>
              <Form.Item
                name={`business_type`}
                label={"Business Type"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select Business Type!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select Business Type--"
                  showSearch
                  filterOption={filterOption}
                  className="w-full mt-2"
                  options={[
                    {
                      label: "Individual",
                      value: "Individual",
                    },
                    {
                      label: "Proprietorship",
                      value: "Proprietorship",
                    },
                    {
                      label: "Pvt. Ltd. / LLP",
                      value: "Pvt Ltd / LLP",
                    },
                  ]}
                />
              </Form.Item>
            </div>

            <div className="flex justify-start items-center mt-2">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="bg-primary outline-none border-none text-white"
                >
                  Save
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AddUser;
